import {
  AppMapperError,
  Mapper,
  nn,
  ReadOnly
  } from 'module/Common';
import { Content } from '../Content';
import { Localized } from 'module/Model/Localized';

export type Page = ReadOnly<Page.Shape>;

export namespace Page {
  export type Shape = {
    id: number;
    date: Date;
    slug: string;
    title: Localized<string>;
    content: Content;
    descriptionEnabled: boolean;
    description: null | Localized<string>;
    headerCount: null | number;
  };

  const create = (input: Page) => input;

  export const mapper = Mapper.errorWrapper(
    err => new AppMapperError('Page', err),
    (input: any, path: Array<string>): Page => {
      const descriptionEnabled = Mapper.exec(
        Mapper.mapSchemaPartial({ description_enabled: Mapper.bool }, v => v.description_enabled),
        input,
        path
      );
      return Mapper.mapSchema(
        {
          id: Mapper.num,
          date: Mapper.date,
          slug: Mapper.str,
          title: Localized.mapperWithDefault('Sans Non', 'No Name'),
          content: Content.mapper,

          description_enabled: Mapper.bool,
          description: !descriptionEnabled
            ? Mapper.ignore(null)
            : Localized.mapperWithDefault('Pas de description.', 'No description.'),
          content_cover_count: !descriptionEnabled ? Mapper.ignore(null) : Mapper.stringInt,
        },
        ({ id, date, slug, title, content, description_enabled, description, content_cover_count }) =>
          create({
            id,
            date,
            slug,
            title,
            content,
            descriptionEnabled: description_enabled,
            description,
            headerCount: content_cover_count,
          })
      )(input, path);
    }
  );

  export const getContent = (model: Page): Content => model.content;
  export const getTitle = (model: Page): Localized<string> => model.title;
  export const getTitleAsText = (model: Page): Localized<string> =>
    Localized.transform(model.title, v => v.replace('<br />', ' ').replace(/[ ]+/, ' '));

  export const isDescriptionEnabled = (model: Page): boolean => model.descriptionEnabled;
  export const getDescription = (model: Page): Localized<string> => nn(model.description);
  export const getHeaderCount = (model: Page): number => nn(model.headerCount);

  export const getHeaderContent = (model: Page): Content => {
    if (!isDescriptionEnabled(model)) {
      return [];
    }
    const content = getContent(model);
    const count = getHeaderCount(model);
    if (content.length <= count) {
      return content;
    }
    return content.slice(0, count);
  };

  export const getBodyContent = (model: Page): Content => {
    const content = getContent(model);
    if (!isDescriptionEnabled(model)) {
      return content;
    }
    const count = getHeaderCount(model);
    if (content.length <= count) {
      return [];
    }
    return content.slice(count);
  };
}



// WEBPACK FOOTER //
// ./src/module/Model/Page/index.ts